import Ages from "./ages";
import { budgetRange, budgetValues } from "./budget-range";
import Currency from "./currencies";
import {
  curriculum,
  curriculumSubjects,
  currculumGrade1,
  currculumGrade2,
} from "./curriculum";
import Countries from "./countries";
import Currencies from "./converter";
import exchangeValues from "./exchange-values";
import genderArray from "./gender-array";
import gradeArray from "./grade-array";
import gradYearsArray from "./grad-year";
import halalFoodValues from "./halal-food-values";
import homeCurrency from "./home-currency";
import locationTypeValues from "./location-type-values";
import NavbarRoutes from "./navbar-routes";
import pageSizes from "./pagesizes";
import supportArray from "./support-array";
import scholarshipValues from "./scholarship-values";
import TimeSlots from "./timeslots";
import testNames from "./test-name-array";
import nationalities from "./nationalityarray";
import ethnicityArray from "./ethnicityarray";
import aiprompts from "./aiprompts";

const UtilityArrays = {
  Ages,
  budgetRange,
  budgetValues,
  Currencies,
  exchangeValues,
  curriculum,
  curriculumSubjects,
  currculumGrade1,
  currculumGrade2,
  Countries,
  Currency,
  ethnicityArray,
  genderArray,
  gradeArray,
  gradYearsArray,
  halalFoodValues,
  homeCurrency,
  locationTypeValues,
  NavbarRoutes,
  pageSizes,
  nationalities,
  supportArray,
  scholarshipValues,
  TimeSlots,
  testNames,
  aiprompts,
};

export default UtilityArrays;
